import ArtefactsCreate from '../../components/artefact/CreateArtefact';

const ArtefactCreatePage = () => {
  return (
    <div className="flex flex-col items-cener gap-5 p-10 h-full">
      <div className="bg-gradient-to-r from-darkPurple to-softPurple w-full p-5 h-auto">
        <p className="text-white">Naujas Artefaktas</p>
      </div>
      <div className="flex justify-center h-full">
        <ArtefactsCreate />
      </div>
    </div>
  );
};

export default ArtefactCreatePage;
